import Message from '../../src/legacy/Message';
export default Message;
